// extracted by mini-css-extract-plugin
export default {"TooltipContent":"styles_TooltipContent__ZP3v5","highlighted":"styles_highlighted__Nu8Z9"};